export default __webpack_public_path__ + "static/media/animateDots.b01fa5e4.svg";